export default "__VITE_ASSET__7b4c94f4__"